<template>
    <div :class="classes" v-bind="attributes">
        <div class="google-map" ref="map"></div>
        <slot></slot>
    </div>
</template>

<script>
  import axios from 'axios';
  export default {
    props: {
      classes: {
        type: String,
        default: ''
      },
      attributes: {
        type: Object,
        default: () => ({})
      },
      zoomLevel: {
        type: Number,
        default: 11,
      },
      center: {
        type: Object,
        default: () => ({
          lat: 41.902546,
          lng: 12.495711
        })
      },
      auto: {
        type: Boolean,
        default: false
      },
      initializeOnBoot: {
        type: Boolean,
        default: true
      },
      endpoint: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        markers: [],
        map: Object,
        bounds: Object,
      }
    },
    methods: {
      addMarker(point) {
        this.$set(this.markers, this.markers.length, point);
      },
      initializeMap() {
        this.map = new google.maps.Map(this.$refs.map, {
          zoom: this.zoomLevel,
          center: {lat: this.center.lat, lng: this.center.lng}
        });
        this.setupMarkers();
      },
      setupMarkers() {
        //if endpoint is present
        let self = this;
        if(this.endpoint) {
            axios.get(this.endpoint).then(response => {
              if(response.data.length > 0) {
                response.data.forEach(marker => {
                  self.addMarker({
                    lat: marker.coordinates.lat,
                    lng: marker.coordinates.lng,
                  });
                });
                self.addMarkersToMap();
              }
            })
        } else {
          self.addMarkersToMap();
        }
      },
      addMarkersToMap() {
        this.bounds = new google.maps.LatLngBounds();
        const markers = this.markers;
        markers.forEach((marker) => {
          marker.googleInstance = new google.maps.Marker({
            position: {lat: marker.lat, lng: marker.lng},
            map: this.map,
          });
          this.bounds.extend(new google.maps.LatLng(marker.lat, marker.lng));
        });
        if (this.auto) {
          this.map.fitBounds(this.bounds);
        } else {
          this.map.setCenter({
            lat: this.center.lat,
            lng: this.center.lng,
          });
          this.map.setZoom(this.zoomLevel);
        }
      },
      refreshMarkers(markers) {
        this.markers = [];
        markers.forEach(marker => {
          this.addMarker({
            lat: marker.coordinates[1],
            lng: marker.coordinates[0],
          });
        });
        this.initializeMap();
        this.setupMarkers();
      },
    },
    created() {
      let self = this;
      this.$root.$on('register-marker', (marker) => {
        this.addMarker({lat: marker.lat, lng: marker.lng});
      });
      this.$root.$on('rubinred.map.refresh', markers => {
        //console.log(markers);
        self.refreshMarkers(markers);
      });
    },
    mounted() {
      window.addEventListener('load', () => {
        if (this.initializeOnBoot) {
          this.initializeMap();
        }
      })
    },
  }
</script>

<style>
    .google-map {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/maps/assets/js/components/RubinredMap.vue